import { defineStore } from "pinia";
import { useContentsStore } from "./ContentsStore";
import { LiveInfo } from "~/entities/LiveInfo";
import { ContentList } from "~/entities/ContentList";

export const useLiveScheduleStore = defineStore("LiveScheduleStore", () => {
  const liveSchedule = ref<LiveInfo>();
  const liveSchedules = ref<ContentList<LiveInfo>>();
  const loading = ref(false);
  const loadingList = ref(false);

  const contentStore = useContentsStore();

  const fetchOne = async (contentsId: string) => {
    loading.value = true;
    liveSchedule.value = undefined;
    try {
      liveSchedule.value = await contentStore.getDetail<LiveInfo>(contentsId);
    } finally {
      loading.value = false;
    }
  };

  const fetch = async (
    page: number,
    pageSize: number,
    planId: string | undefined = undefined,
    options?: Record<string, any>,
  ) => {
    loadingList.value = true;
    liveSchedules.value = undefined;
    try {
      liveSchedules.value = await contentStore.getList<ContentList<LiveInfo>>(page, pageSize, {
        contents_types: ["schedule"],
        plan_id: planId,
        ...options,
      });
    } finally {
      loadingList.value = false;
    }
  };

  return {
    liveSchedule,
    liveSchedules,
    loading,
    loadingList,
    fetchOne,
    fetch,
  };
});
